import React from 'react';
import { Download } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Dashboard } from './Dashboard';
import { clients } from '../lib/data';
export function ClientDashboard() {
  const client = clients[0];
  return <div className="min-h-screen bg-background flex flex-col" data-id="element-406">
      {/* Client Header */}
      <header className="py-3 md:h-16 border-b border-border bg-card flex flex-col md:flex-row md:items-center justify-between px-4 md:px-8 flex-shrink-0 gap-3 md:gap-0" data-id="element-407">
        <div className="flex items-center gap-3 md:gap-4" data-id="element-408">
          <img src={client.logo} alt={client.name} className="max-w-[100px] max-h-[32px] object-contain object-left flex-shrink-0" data-id="element-409" />
          <div data-id="element-410">
            <h1 className="font-semibold text-sm" data-id="element-411">{client.name}</h1>
            <p className="text-[10px] md:text-xs text-muted-foreground" data-id="element-412">
              Rassegna Stampa Analytics
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between md:justify-end gap-4 w-full md:w-auto" data-id="element-413">
          <span className="text-xs md:text-sm text-muted-foreground" data-id="element-414">
            Aprile 2025
          </span>
          <Button className="bg-accent hover:bg-accent/90 text-accent-foreground h-10 md:h-11 text-xs md:text-sm rounded-full" data-id="element-415">
            <Download className="h-3 w-3 md:h-4 md:w-4 mr-1.5 md:mr-2" data-id="element-416" />
            Scarica Report PDF
          </Button>
        </div>
      </header>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-417">
        <div data-id="element-418">
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mb-2" data-id="element-419">
            {client.name}
          </h1>
          <p className="text-base text-muted-foreground" data-id="element-420">
            Panoramica e performance media
          </p>
        </div>
        <Button className="h-10 md:h-11 text-xs md:text-sm rounded-full" data-id="element-421">
          <Download className="h-4 w-4 mr-2" data-id="element-422" />
          Scarica Report
        </Button>
      </div>

      {/* Main Content - Reusing Dashboard but without sidebar */}
      <main className="flex-1 overflow-auto" data-id="element-423">
        <Dashboard data-id="element-424" />
      </main>
    </div>;
}